import React from 'react';
import logo from './images/logo.png';

function WhatWeDo({ services }) {
  // Using props instead of local state

  return (
    <>
      {/* Main Content - "What We Do" */}
      <main className="what-we-do-main">
        <section className="what-we-do-hero">
          <h1 className="what-we-do-heading">WHAT WE DO</h1>
          <div className="services-container">
            {services.map((service) => (
              <div className="service-pair" key={service.id}>
                <a href={service.link} className="service-card-link">
                  <div className="service-card">
                    <div className="service-image-container">
                      <img src={service.image} alt={service.title} className="service-image" />
                    </div>
                  </div>
                </a>
                <div className="service-name-container">
                  <a href={service.link} className="service-name-link">
                    <h3 className="service-name" style={{fontStyle: "normal"}}>{service.title}</h3>
                    
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}

export default WhatWeDo;
